import {
    AppBar, Box,
    Button,
    ButtonGroup,
    Container, Divider,
    Drawer,
    IconButton, List, ListItemButton, Menu, MenuItem,
    Popover,
    Stack,
    Toolbar, Typography, useMediaQuery
} from "@mui/material";
import Logo from "../Icons/Logo";
import SearchIcon from '@mui/icons-material/Search';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import PersonIcon from '@mui/icons-material/Person';
import React, {memo, useContext, useEffect, useState} from "react";
import CurrencyFormatter from '../CurrencyFormatter/CurrencyFormatter';
import {HeaderLink} from "../HeaderLink/HeaderLink";
import {useQuery} from "@apollo/client";
import {GET_USER} from "../../store/queries/GetUser";
import LogoSmall from "../Icons/LogoSmall";
import MenuIcon from '@mui/icons-material/Menu';
import {ListHeaderLink} from "../HeaderLink/ListHeaderLink";
import {CustomLink} from "../CustomLink/CustomLink";
import Close from "@mui/icons-material/Close";
import {Navigation} from '../../views/user/components/navigation/Navigation';
import {useTheme} from "@mui/material/styles";
import {SearchField} from "../SearchField/SearchField";
import {useTranslation} from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import languageList from "../../utils/languageList";
import {RouteContext} from "../../routes/RouteContext";
import {UserBadge} from "../../views/user/components/details/UserBadge";
import {getTranslationOfCurrentLocation} from "../../routes/AppRoutes";
import {useLocation} from "react-router-dom";
import {Notifications} from "../Notifications/Notifications";
import {GetUserQuery, User} from "../../gql/graphql";
import {ScreenReaderSpan} from "../ScreenReaderSpan/ScreenReaderSpan";
import {css} from "@linaria/core";
import {media} from "../../utils/responsive";
import QrCodeIcon from '@mui/icons-material/QrCode';
import DepositButton from "../DepositButton/DepositButton";
import {InstallPwaModal} from "../InstallPwa/InstallPwaModal";

export const Header = memo(() => {
    const {t, i18n} = useTranslation();
    const getUser = useQuery<GetUserQuery>(GET_USER);
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElLanguageSelector, setAnchorElLanguageSelector] = React.useState<HTMLElement | null>(null);
    const [drawerOpen, setDrawerOpen] = React.useState<boolean>(false);
    const [accountDrawerOpen, setAccountDrawerOpen] = React.useState<boolean>(false);
    const [openSearchField, setOpenSearchField] = useState(false);
    const openLanguageSelector = Boolean(anchorElLanguageSelector);

    const openPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const closePopover = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const toggleSearchField = () => {
        setOpenSearchField(!openSearchField);
    }

    const handleOpenLanguageSelector = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElLanguageSelector(event.currentTarget);
    }

    const handleCloseLanguageSelector = () => {
        setAnchorElLanguageSelector(null);
    }

    return (
        <>
            <>
                <AppBar position={'fixed'} sx={{backgroundColor: '#000'}}>
                    <div className={css`${media.xs} {
                      padding: 0 16px
                    }
                    ;

                      ${media.sm} {
                        padding: 0 24px
                      }
                    ;`}>
                        <Toolbar disableGutters
                                 sx={{justifyContent: 'space-between', alignItems: 'stretch', minHeight: {sm: 56}}}>
                            <div
                                className={css`${media.xs} {
                                  display: flex
                                }
                                ;

                                  ${media.md} {
                                    display: none
                                  }
                                ;
                                  flex-grow: 0;
                                  align-items: center;`}>
                                <IconButton onClick={() => setDrawerOpen(true)} aria-label={t('Open menu')}>
                                    <MenuIcon
                                        sx={{color: (theme) => theme.palette.primary.contrastText}}/>
                                </IconButton>
                                <>
                                    <IconButton onClick={toggleSearchField}
                                                sx={{display: {xs: 'none', sm: 'flex'}}}>
                                        <SearchIcon
                                            sx={{color: (theme) => theme.palette.primary.contrastText}}/>
                                    </IconButton>
                                </>
                            </div>

                            <div
                                className={css`display: flex;
                                  flex-direction: row;
                                  flex-grow: 0;
                                  align-items: center;

                                  ${media.xs} {
                                    display: none
                                  }
                                ;

                                  ${media.md} {
                                    display: flex
                                  }
                                ;`}>
                                <IconButton onClick={toggleSearchField}>
                                    <ScreenReaderSpan>{t('search')}</ScreenReaderSpan>
                                    <SearchIcon
                                        sx={{color: (theme) => theme.palette.primary.contrastText}}/>
                                </IconButton>
                                <HeaderLink to="/" activeOn={["/games/*"]} sx={{ml: 1}}>{t('casino')}</HeaderLink>
                                <HeaderLink to="/tournaments" sx={{ml: 1}}>{t('tournaments')}</HeaderLink>
                            </div>

                            <SearchField open={openSearchField}
                                         onClose={toggleSearchField}/>

                            <div
                                className={css`${media.xs} {
                                  display: flex
                                }
                                ;

                                  ${media.sm} {
                                    display: none
                                  }
                                ;
                                  flex-grow: 1;
                                  justify-content: flex-start;
                                  align-items: center;
                                  padding-left: 16px;

                                  & a {
                                    color: #fff
                                  }`}>
                                <CustomLink to={'/'} area-label={t('PepperMill Casino')}><LogoSmall
                                    sx={{height: '50px', width: '30px'}} role={'img'}
                                    aria-hidden="false"/></CustomLink>
                            </div>
                            <div
                                className={css`${media.xs} {
                                  display: none
                                }
                                ;

                                  ${media.sm} {
                                    display: flex
                                  }
                                ;
                                  flex-grow: 0;
                                  justify-content: center;
                                  align-items: center;

                                  & a {
                                    color: #fff
                                  }`}>
                                <CustomLink to={'/'}><Logo sx={{height: '50px', width: '180px'}}
                                                           aria-hidden={'false'}/></CustomLink>
                            </div>
                            <div
                                className={css`display: flex;
                                  flex-direction: row;
                                  flex-grow: 0;
                                  align-items: center;`}>
                                <div
                                    className={css`${media.xs} {
                                      display: none
                                    }
                                    ;

                                      ${media.md} {
                                        display: flex
                                      }
                                    ;
                                      height: 100%`}>
                                    <HeaderLink to="/promotions">{t('promotions')}</HeaderLink>
                                </div>
                                <Button
                                    id="language-selector"
                                    aria-controls={openLanguageSelector ? 'filter-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openLanguageSelector ? 'true' : undefined}
                                    disableElevation
                                    onClick={handleOpenLanguageSelector}
                                    endIcon={<KeyboardArrowDownIcon/>}
                                    sx={{
                                        color: '#ffffff',
                                        textTransform: 'uppercase',
                                        marginX: '5px',
                                        padding: '12px',
                                        whiteSpace: 'nowrap',
                                        display: {xs: 'none', md: 'flex'}
                                    }}
                                >
                                    {i18n.language}
                                </Button>
                                {getUser.data?.identity === null && (
                                    <div className={css`display: flex;
                                      align-items: center;
                                      flex-direction: row;`}>
                                        <Button component={CustomLink} to="/login"
                                                variant="outlined"
                                                sx={{borderRadius: 8, height: '32px', ml: 1}}>{t('login')}</Button>
                                        <Button component={CustomLink} to="/register"
                                                variant="contained"
                                                sx={{
                                                    borderRadius: 8,
                                                    height: '32px',
                                                    ml: 1
                                                }}>{t('register')}</Button>
                                    </div>
                                )}

                                {getUser.data?.identity && (
                                    <div className={css`display: flex;
                                      flex-direction: row;
                                      align-items: center;`}>
                                        <Button onClick={() => setAccountDrawerOpen(true)} sx={{
                                            flexDirection: 'column',
                                            padding: 0,
                                            display: {xs: 'flex', md: 'none'}
                                        }}>
                                            <UserBadge>
                                                <PersonIcon sx={{
                                                    color: (theme) => theme.palette.primary.contrastText,
                                                    fontSize: 45, pb: 2
                                                }}/>
                                            </UserBadge>
                                            <div
                                                className={css`position: absolute;
                                                  top: 24px;
                                                  white-space: nowrap;`}>
                                                <CurrencyFormatter
                                                    currency={(getUser.data?.identity as User).wallet.currency ?? "EUR"}
                                                    quantity={(getUser.data?.identity as User).wallet.balance}/>
                                            </div>
                                        </Button>
                                        <Button onClick={openPopover} sx={{
                                            flexDirection: 'column',
                                            padding: 0,
                                            display: {xs: 'none', md: 'flex'}
                                        }}>

                                            <UserBadge>
                                                <PersonIcon sx={{
                                                    color: (theme) => theme.palette.primary.contrastText,
                                                    fontSize: 45, pb: 2
                                                }}/>
                                            </UserBadge>
                                            <div
                                                className={css`position: absolute;
                                                  top: 24px;
                                                  white-space: nowrap;`}>
                                                <CurrencyFormatter
                                                    currency={(getUser.data?.identity as User).wallet.currency ?? "EUR"}
                                                    quantity={(getUser.data?.identity as User).wallet.balance}/>
                                            </div>
                                        </Button>
                                        <Popover
                                            open={open}
                                            anchorEl={anchorEl}
                                            onClose={closePopover}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                        >
                                            <div className={css`width: 216px`}>
                                                <Navigation showLogout={true} variant={'dense'}
                                                            callBack={closePopover}/>
                                            </div>
                                        </Popover>
                                        <DepositButton/>
                                        {!isMedium && (
                                            <IconButton component={'a'}
                                                        href={`https://support.peppermillcasino.be/${i18n.language}/support/home`}
                                                        target={"_blank"}>
                                                <ContactSupportIcon
                                                    sx={{color: (theme) => theme.palette.primary.contrastText}}/>
                                            </IconButton>
                                        )}
                                        <Notifications/>
                                    </div>
                                )}
                            </div>
                        </Toolbar>
                    </div>
                </AppBar>
                <Toolbar sx={{minHeight: {sm: 56}}}/>
            </>

            <Drawer
                anchor={'left'}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                sx={{
                    '& .MuiPaper-root': {
                        background: (theme) => theme.palette.common.black
                    },
                    '& .MuiBackdrop-root': {
                        backdropFilter: 'blur(5px)'
                    }
                }}
            >
                <div className={css`display: flex; flex-direction: column; width: 300px; height: 100%`} role="presentation" onKeyDown={() => setDrawerOpen(false)}>
                    <div className={css`display: flex;
                      flex-direction: row;
                      justify-content: space-between;`}>
                        <IconButton sx={{mt: 1, ml: 2}} onClick={() => setDrawerOpen(false)}>
                            <MenuIcon
                                sx={{color: (theme) => theme.palette.primary.contrastText}}/>
                        </IconButton>
                        <Button
                            id="language-selector"
                            aria-controls={openLanguageSelector ? 'filter-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openLanguageSelector ? 'true' : undefined}
                            disableElevation
                            onClick={handleOpenLanguageSelector}
                            endIcon={<KeyboardArrowDownIcon/>}
                            sx={{
                                color: '#ffffff',
                                textTransform: 'none',
                                marginX: '5px',
                                padding: '12px',
                                whiteSpace: 'nowrap',
                                mt: 1,
                                mr: 2
                            }}
                        >
                            {languageList.find(x => x.code === i18n.language)?.language}
                        </Button>
                    </div>
                    <List sx={{mt: 2}}>
                        <ListHeaderLink to={'/'} onClick={() => setDrawerOpen(false)}>{t('casino')}</ListHeaderLink>
                        <ListHeaderLink to={'/tournaments'}
                                        onClick={() => setDrawerOpen(false)}>{t('tournaments')}</ListHeaderLink>
                        <ListHeaderLink to={'/promotions'}
                                        onClick={() => setDrawerOpen(false)}>{t('promotions')}</ListHeaderLink>
                        <ListItemButton disableRipple sx={{pl: 3, color: (theme) => theme.palette.primary.contrastText}}
                                        component={'a'}
                                        href={`https://support.peppermillcasino.be/${i18n.language}/support/home`}
                                        target={"_blank"}
                                        onClick={() => setDrawerOpen(false)}>{t('support')}</ListItemButton>
                    </List>
                    <div className={css`flex: 1`}></div>
                    <InstallPwaModal/>
                </div>
            </Drawer>
            <Drawer
                anchor={'right'}
                open={accountDrawerOpen}
                onClose={() => setAccountDrawerOpen(false)}
            >
                <div className={css`width: 256px;
                  position: relative;`} role="presentation"
                     onClick={() => setAccountDrawerOpen(false)} onKeyDown={() => setDrawerOpen(false)}>
                    <Box sx={{position: 'absolute', right: 0, zIndex: 2}}>
                        <IconButton sx={{mt: 1, ml: 2,}}
                                    onClick={() => setAccountDrawerOpen(false)}>
                            <Close/>
                        </IconButton>
                    </Box>

                    <Navigation showLogout={true} variant={'withoutCollapse'} showUserDetails
                                callBack={() => setAccountDrawerOpen(false)}/>
                </div>
            </Drawer>
            <Menu
                id="filter-menu"
                anchorEl={anchorElLanguageSelector}
                open={openLanguageSelector}
                onClose={handleCloseLanguageSelector}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {languageList.map(({language, code}, key) => (
                    <MenuItem key={key} component={CustomLink} onClick={handleCloseLanguageSelector}
                              to={getTranslationOfCurrentLocation(location, code, t)}>{language}</MenuItem>
                ))}
            </Menu>
        </>
    );
})
